import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AddOn } from '../interfaces/IAddOn';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AddOnService {
  api: string = environment.api + '/addOns';
  invMapApi: string = environment.api + '/inventory-mapping/addon';

  constructor(private httpClient: HttpClient) {}

  createAddOn(addOn: AddOn): Observable<any> {
    return this.httpClient.post(this.api + '/create', addOn, {
      withCredentials: true,
    });
  }
  removeAddOn(addOnId: number): Observable<any> {
    return this.httpClient.delete(this.api + '/' + addOnId, {
      withCredentials: true,
    });
  }
  deleteAddonsByMenu(menuId: number): Observable<any> {
    return this.httpClient.delete(this.api + '/menu/' + menuId, {
      withCredentials: true,
    });
  }

  getAddOns(menuId: number, status?: boolean): Observable<any> {
    const statusParam = status !== undefined ? `?status=${status}` : '?status=true';
    return this.httpClient.get(`${this.api}/getAll/${menuId}${statusParam}`);
  }
  updateAddOn(addOn: AddOn): Observable<any> {
    const payload = {
      addOnName: addOn.addOnName,
      addOnPrice: addOn.addOnPrice,
      loyaltyPointsRequired: '',
      active: addOn.active,
      addOnDescription: addOn.addOnDescription,
      deleted: false,
      menuId: addOn.menuId,
      imageLink: addOn.imageLink || '',
      id: addOn.id,
      translateModelList: addOn.translateModelList || [],
    };
    return this.httpClient.put(this.api + '/update', payload, {
      withCredentials: true,
    });
  }

  mapWithInventory(addonId: number, inventoryIds: number[]): Observable<any> {
    return this.httpClient.post(
      `${this.api}/map-with-inventory/${addonId}`,
      inventoryIds,
      { withCredentials: true }
    );
  }

  updateMeasurement(mappingId: number, measurement: number, unitId: number) {
    return this.httpClient.patch(
      `${this.invMapApi}/${mappingId}/${measurement}/${unitId}`,
      { withCredentials: true }
    );
  }

  updateAddOnName(addonId: number, updatedName: string): Observable<any> {
    return this.httpClient.patch(`${this.api}/${addonId}/${updatedName}`, {
      withCredentials: true,
    });
  }

  updateAddOnPrice(addonId: number, updatedPrice: number): Observable<any> {
    return this.httpClient.patch(
      `${this.api}/price/${addonId}/${updatedPrice}`,
      { withCredentials: true }
    );
  }

  toggleAddOn(addOn: AddOn): Observable<any> {
    return this.httpClient.patch(
      `${this.api}/status/${addOn.id}/${addOn.active}`,
      null
    );
  }

  updateImage(id: number, imageLink: string): Observable<any> {
    return this.httpClient.patch(`${this.api}/image/${id}/${imageLink}`, {});
  }

  /**
   * duplicate addons
   * @param oldMenuId 
   * @param newMenuId 
   * @returns 
   */
  duplicateAddons(oldMenuId: number, newMenuId: number): Observable<any> {
    return this.httpClient.get(`${this.api}/duplicate/${oldMenuId}/${newMenuId}`);
  }

}
